export default "__VITE_ASSET__DRhXD1Qe__"